import {
  getAvailableLendersByLenderCommissions,
  isThereAnyContactWhoIsCompanyOrSelfEmployed,
  areAllContactsCompanies
} from '__core/shared/util/salestrekker';
/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $mdDialog,
  $location,
  $anchorScroll,
  $window,
  cookies,
  webpage,
  authenticationService,
  jsonFactory,
  eventService,
  dateTimeService,
  validationService,
  helperService,
  pdfService,
  accountService,
  Contact,
  contactService,
  contactsService,
  expensesService,
  incomeService,
  Asset,
  Ownership,
  assetsService,
  LabelType,
  Liability,
  liabilitiesService,
  Insurance,
  insurancesService,
  otherAdvisersService,
  Objective,
  ticketService,
  ticketsService,
  TicketStatusHistory,
  workflowService,
  labelsService,
  HomeLoan,
  HomeLoanSearchProduct,
  ReviewProduct,
  CompareProduct,
  HomeLoanCompliance,
  HomeLoanVerificationApplicant,
  homeLoanService,
  lendersService,
  productsService,
  Commission,
  commissionsService,
  documentService,
  documentsService,
  notesService,
  lodgementsService,
  lodgementService,
  uiService,
  flexService,
  accessService,
  financeService,
  Product,
  TransactionType,
  openBankingService,
  DOCUMENT,
  LODGEMENT
) => {
  $scope.Model = {
    hasBrokerToolsEnabled: $rootScope.hasBrokerToolsEnabled(),
    canSeeNeedsAnalysis: $rootScope.canSeeNeedsAnalysis(),
    countries: [],
    addresses: [],
    organizationCountry: helperService.getOrganizationCountry(),
    currentTicket: {},
    currentWorkflow: {},
    currentTicketOwner: {},
    currentHomeLoan: {},
    currentGateway: {},
    availableContacts: [],
    availableClients: [],
    availablePersonOnlyContacts: [],
    availableCompanyOnlyContacts: [],
    availableNonBorrowingSpouses: [],
    availableSecurityGuarantors: [],
    availableServicingGuarantors: [],
    availableSpouses: [],
    availableDocuments: [],
    availableComplianceTypes: _.sortBy(DOCUMENT.TYPES, 'value'),
    availableLenders: [],
    filteredLenders: [],
    availableLendersPerCountry: [],
    availableLendersDocuments: [],
    availableProducts: [],
    availableCommissions: [],
    selectedCommission: [],
    availableLabels: [],
    availableIncomeTypes: incomeService.getAvailableIncomeTypes(),
    availableAssetTypes: assetsService.getAvailableAssetTypes(),
    availableLiabilityTypes: [],
    availableInsuranceTypes: [],
    availableOtherAdviserTypes: [],
    outboundReferrers: [],
    activeSection: 'applicant0',
    availableSections: [],
    factFindSections: [
      'income',
      'expenses',
      'assets',
      'liabilities',
      'needsAndObjectives',
      'productRequirements',
      'insurance',
      'otherAdvisers'
    ],
    homeLoanSections: [
      'securityDetails',
      'fundingWorksheet',
      'maximumBorrowing',
      'searchLoanProducts',
      'reviewLoanProducts',
      'compareLoanProducts',
      'commissions',
      'compliance',
      'summary',
      'diversificationOpportunities',
      'gateway'
    ],
    isSidebarMinimized:
      cookies.get('stSidebar') && cookies.get('stSidebar') !== undefined
        ? cookies.get('stSidebar')
        : false,
    availablePdfTypes: helperService.getAvailablePdfTypes(),
    maximumBorrowing: [],
    hasMaximumBorrowingEstimateData: false,
    availableAddresses: [],
    attachmentsCompliance: [],
    attachmentsFiles: [],
    searchFields: {},
    lodgement: {
      applyOnlineApplication: null,
      simpologyApplication: null,
      isApplyOnlineApplicationReady: false,
      isSimpologyApplicationReady: false
    },
    selectedSimpologyFiles: [],
    simpologyAttachFiles: false,
    simpologyUrl: '',
    isSimpologyApplicationReady: false,
    isSimpologyOpenLoading: false,
    isSimpologyUpdateLoading: false,
    isApplyOnlineApplicationReady: false,
    isApplyOnlineOpenLoading: false,
    isApplyOnlineUpdateLoading: false,
    isCreatingMercuryOpportunity: false,
    validation: {
      errors: [],
      incomeErrors: [],
      expensesErrors: [],
      assetsErrors: [],
      liabilitiesErrors: [],
      needsAndObjectivesErrors: [],
      productRequirementsErrors: [],
      securityDetailsErrors: [],
      bidErrors: []
    },
    openBankingData: [],
    openBankingContacts: [],
    isReady: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadLendersPerCountry = () => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [$scope.Model.organizationCountry.cca2]
      })
      .then((lenders) => {
        if (lenders && lenders.length) {
          $scope.Model.availableLendersPerCountry = lenders;
        }
        deferred.resolve(lenders);
      });
    return deferred.promise;
  };

  const loadLabels = () => {
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableLabels = labels;
        $scope.Model.availableFileLabels = labels.filter(
          (l) => l.type.name === LabelType.file.name && l.isLocked
        );
        $scope.Model.availableContactLabels = labels.filter(
          (l) => l.type.name === LabelType.contact.name
        );
        $scope.Model.availableComplianceFileLabels = _.filter(
          labels,
          (l) => l.type.name === LabelType.file.name && l.isLocked
        );
      });
  };

  const loadWorkflow = () => {
    workflowService.readWorkflow({ id: $stateParams.id }).then((workflow) => {
      $scope.Model.currentWorkflow = workflow;
    });
  };

  const loadTicket = (idTicket) => {
    const deferred = $q.defer();
    ticketService.readTicket({ id: idTicket }).then((ticket) => {
      $scope.Model.currentTicket = ticket;
      deferred.resolve(ticket);
    });
    return deferred.promise;
  };

  const loadAccount = (idOwner) => {
    const deferred = $q.defer();
    accountService.readAccount({ id: idOwner }).then((account) => {
      $scope.Model.currentTicketOwner = account;
      deferred.resolve(account);
    });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService.getSpecific({ idContacts, isActive: true }).then((contacts) => {
      $scope.Model.availableContacts = _.compact($scope.sortByIdContacts(contacts));
      const len = $scope.Model.availableContacts?.length || 0;
      for (let c = 0; c < len; c += 1) {
        $scope.Model.validation[`applicant${c}Errors`] = [];
      }
      if ($scope.Model.availableContacts?.length) {
        $scope.Model.availablePersonOnlyContacts = _.filter(
          $scope.Model.availableContacts,
          (c) => !c.isCompany
        );
        $scope.Model.availableCompanyOnlyContacts = _.filter(
          $scope.Model.availableContacts,
          (c) => c.isCompany
        );
        $scope.Model.availableNonBorrowingSpouses = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            helperService.isClientNonBorrowingSpouse({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
        $scope.Model.availableSecurityGuarantors = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            helperService.isClientSecurityGuarantor({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
        $scope.Model.availableSecurityGuarantors = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            helperService.isClientServicingGuarantor({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
        $scope.Model.availableClients = _.filter(
          $scope.Model.availableContacts,
          (c) =>
            !helperService.isClientSecurityGuarantor({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            }) &&
            !helperService.isClientNonBorrowingSpouse({
              ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
              idContact: c.id
            })
        );
      }
      deferred.resolve(contacts);
    });
    return deferred.promise;
  };

  const loadSpouses = (idContacts) => {
    contactsService.getSpecific({ idContacts, isActive: true }).then((spouses) => {
      $scope.Model.availableSpouses = spouses;
    });
  };

  const loadCommissions = () => {
    commissionsService.getAvailable({ isActive: true }).then((data) => {
      if (data && data.length) {
        const commissionBlank = Commission.blank();
        commissionBlank.id = '';
        commissionBlank.name = 'Select one';
        data.unshift(commissionBlank);
        $scope.Model.availableCommissions = data;
      }
    });
  };

  const loadLendersDocuments = (idLenders) => {
    lendersService
      .getDocuments({
        idLenders,
        types: ['LOGO', 'CALCULATOR', 'CALCULATOR_SCHEMA', 'SUPPORTING_DOCUMENT']
      })
      .then((lendersDocuments) => {
        if (lendersDocuments?.length) {
          $scope.Model.availableLendersDocuments = lendersDocuments;
        }
      });
  };

  const loadLenders = (currentTicketOwner) => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [$scope.Model.organizationCountry.cca2],
        type: 'RESIDENTIAL'
      })
      .then((lenders) => {
        if (lenders?.length) {
          $scope.Model.availableLenders = getAvailableLendersByLenderCommissions(
            lenders,
            $rootScope.CurrentOrganization,
            currentTicketOwner,
            $scope.Model.currentWorkflow,
            $rootScope.IsEnterprise,
            false
          );
          if ($scope.Model.availableLenders?.length) {
            $scope.Model.filteredLenders = $scope.Model.availableLenders;
            const idLenders = _.compact(_.uniq(_.map($scope.Model.availableLenders, 'id')));
            loadLendersDocuments(idLenders);
          }
        }
        deferred.resolve(lenders);
      });
    return deferred.promise;
  };

  const loadHomeLoan = (idHomeLoan) => {
    const deferred = $q.defer();
    homeLoanService.readHomeLoan({ id: idHomeLoan }).then((homeLoan) => {
      $scope.Model.currentHomeLoan = homeLoan;
      deferred.resolve(homeLoan);
    });
    return deferred.promise;
  };

  const loadDocuments = () => {
    documentsService.getAvailable({ isActive: true }).then((documents) => {
      $scope.Model.availableDocuments = documents;
    });
  };

  const loadNotes = () => {
    const deferred = $q.defer();
    notesService
      .getSpecific({ idTickets: $scope.Model.currentTicket.id, isActive: true })
      .then((notes) => {
        $scope.Model.availableNotes = notes;
        deferred.resolve(notes);
      });
    return deferred.promise;
  };

  const loadAttachments = (notes) => {
    $timeout(() => {
      let noteAttachments = notes.map((note) => {
        const attachments = [];
        for (let n = 0; n < note.attachments.length; n += 1) {
          const attach = note.attachments[n];
          attach.idNote = note.id;
          attach.noteType = note.type;
          if (_.find(attachments, { id: attach.id }) === undefined) {
            attachments.push(attach);
          }
        }
        return attachments;
      });
      noteAttachments = _.flatten(noteAttachments);
      $scope.Model.attachmentsFiles = _.union(
        $scope.Model.currentTicket.attachments,
        noteAttachments
      );
      if ($scope.Model.attachmentsFiles.length) {
        $scope.Model.attachmentsCompliance = $scope.Model.attachmentsFiles.filter(
          (a) => (a.noteType?.name !== 'video') !== undefined
        );
      }
      if ($scope.Model.attachmentsCompliance.length) {
        $scope.Model.attachmentsFiles = $scope.Model.attachmentsFiles.filter(
          (a) => a.noteType?.name !== 'video'
        );
      }
    });
  };

  const loadLodgedApplication = () => {
    lodgementsService.clearCache();
    lodgementsService
      .getAvailable({
        idTicket: $scope.Model.currentTicket.id,
        isActive: true,
        fields: LODGEMENT.FIELDS.APPLICATION,
        ignoreCache: true
      })
      .then((response) => {
        $scope.Model.lodgement.isApplyOnlineApplicationReady = true;
        $scope.Model.lodgement.applyOnlineApplication = _.find(
          response,
          (application) => application.type === 'applyonline'
        );
        $scope.Model.lodgement.isSimpologyApplicationReady = true;
        $scope.Model.lodgement.simpologyApplication = _.find(
          response,
          (application) => application.type === 'simpology'
        );
      });
  };

  const loadOpenBanking = () => {
    const deferred = $q.defer();
    if (
      $rootScope.isDev() &&
      $scope.Model.currentTicket?.openBanking?.length &&
      $scope.Model.currentTicket?.sharedWith?.clientProfile?.length
    ) {
      const idContacts = [];
      const len = $scope.Model.currentTicket?.sharedWith?.clientProfile?.length || 0;
      for (let c = 0; c < len; c += 1) {
        const clientProfile = $scope.Model.currentTicket?.sharedWith?.clientProfile[c];
        const openBanking = _.find(
          $scope.Model.currentTicket?.openBanking || [],
          (o) => o?.idContact === clientProfile?.idClient && o?.isFinished && o?.hasData
        );
        if (
          clientProfile?.integrations?.isOpenBankingEnabled &&
          _.indexOf(
            $scope.Model.currentTicket?.sharedWith?.idClientsWithAccess || [],
            clientProfile?.idClient
          ) > -1 &&
          openBanking
        ) {
          idContacts.push(clientProfile?.idClient);
        }
      }
      deferred.resolve([]);
    } else {
      deferred.resolve([]);
    }
    return deferred.promise;
  };

  const initialize = () => {
    loadLendersPerCountry();
    loadLabels();
    loadWorkflow();
    loadCommissions();
    $q.all([
      jsonFactory.getCountries(),
      jsonFactory.getOccupations(),
      jsonFactory.getIndustries()
    ]).then((res) => {
      const countries = res[0];
      const occupations = res[1];
      const industries = res[2];
      $scope.Model.countries = countries;
      $scope.Model.occupations = occupations;
      $scope.Model.industries = industries;

      loadTicket($stateParams.dd).then(() => {
        webpage.pageTitle($scope.Model.currentTicket.getName());
        $scope.getLiabilityTypes();
        $scope.getInsuranceTypes();
        $scope.getOtherAdviserTypes();

        $scope.Model.outboundReferrers = accessService.getOutbound(
          $scope.Model.currentTicket.idWorkflow,
          $scope.Model.currentTicket.idStage
        );

        loadContacts($scope.Model.currentTicket.idClients).then(() => {
          loadOpenBanking().then(() => {
            for (let c = 0; c < $scope.Model.availableContacts.length; c += 1) {
              $scope.Model.availableSections.push(`applicant${c}`);
            }

            if (!$scope.showIncome()) {
              const idx = $scope.Model.factFindSections.indexOf('income');
              $scope.Model.factFindSections.splice(idx, 1);
            }
            if (!$scope.showExpenses()) {
              const idx = $scope.Model.factFindSections.indexOf('expenses');
              $scope.Model.factFindSections.splice(idx, 1);
            }
            if (!$scope.showObjectivesInsurancesAndOtherAdvisers()) {
              const oIdx = $scope.Model.factFindSections.indexOf('needsAndObjectives');
              $scope.Model.factFindSections.splice(oIdx, 1);
              const pIdx = $scope.Model.factFindSections.indexOf('productRequirements');
              $scope.Model.factFindSections.splice(pIdx, 1);
              const iIdx = $scope.Model.factFindSections.indexOf('insurance');
              $scope.Model.factFindSections.splice(iIdx, 1);
              const oAIdx = $scope.Model.factFindSections.indexOf('otherAdvisers');
              $scope.Model.factFindSections.splice(oAIdx, 1);
            }

            let idSpouses = _.map(
              _.filter(
                $scope.Model.availablePersonOnlyContacts,
                (c) => c.person.information.idSpouse && c.person.information.idSpouse !== ''
              ),
              (s) => s.person.information.idSpouse
            );
            idSpouses = _.uniq(_.compact(idSpouses));

            if (idSpouses.length) {
              loadSpouses(idSpouses);
            }

            for (let a = 0; a < $scope.Model.currentTicket.assets.length; a += 1) {
              if (!$scope.Model.currentTicket.assets[a].ownership.length) {
                $scope.Model.currentTicket.assets[a].ownership =
                  helperService.setOwnershipOfAssetOrLiability(
                    $scope.Model.availableContacts,
                    false
                  );
              }
            }
            for (let l = 0; l < $scope.Model.currentTicket.liabilities.length; l += 1) {
              if (!$scope.Model.currentTicket.liabilities[l].ownership.length) {
                $scope.Model.currentTicket.liabilities[l].ownership =
                  helperService.setOwnershipOfAssetOrLiability(
                    $scope.Model.availableContacts,
                    false
                  );
              }
            }

            $scope.Model.availableSections = $scope.Model.availableSections.concat(
              $scope.Model.factFindSections
            );
            loadAccount($scope.Model.currentTicket.idOwner).then(() => {
              loadLenders($scope.Model.currentTicketOwner).then(() => {
                if (
                  $scope.hasHomeLoanTools() &&
                  $scope.isLenderExistingInTicketOwnersLenderAccreditations()
                ) {
                  $scope.Model.availableSections = $scope.Model.availableSections.concat(
                    $scope.Model.homeLoanSections
                  );
                  if ($scope.Model.canSeeNeedsAnalysis) {
                    const sIdx = $scope.Model.availableSections.indexOf('securityDetails');
                    $scope.Model.availableSections.splice(sIdx, 0, 'needsAnalysis');
                  }
                  if (
                    $scope.Model.currentTicket.idLoan === undefined ||
                    $scope.Model.currentTicket.idLoan === ''
                  ) {
                    $scope.Model.currentHomeLoan = HomeLoan.blank();
                    $scope.Model.currentHomeLoan.idTicket = $scope.Model.currentTicket.id;
                    $scope.Model.currentHomeLoan.idOwner = $scope.Model.currentTicket.idOwner;
                    $scope.verificationsApplicantsIdentified();
                    $scope.getAllAddresses();
                    $scope.Model.isReady = true;
                  } else {
                    loadHomeLoan($scope.Model.currentTicket.idLoan).then(() => {
                      $scope.Model.addresses = _.map(
                        $scope.Model.currentHomeLoan?.securityDetails?.securitySplits,
                        (security) => security.address
                      );

                      if (
                        $scope.areThereSecuritiesWithTransactionTypeOfRefinanceOrEquityRelease()
                      ) {
                        const cIdx = $scope.Model.availableSections.indexOf('commissions');
                        $scope.Model.availableSections.splice(cIdx, 0, 'refinanceAnalysis');
                      }

                      const rLen = $scope.Model.currentHomeLoan?.reviewProducts?.length || 0;
                      for (let p = 0; p < rLen; p += 1) {
                        const reviewProduct = $scope.Model.currentHomeLoan?.reviewProducts[p];
                        const pLen = reviewProduct?.productSplits?.length || 0;
                        for (let s = 0; s < pLen; s += 1) {
                          if (_.isEmpty(reviewProduct?.productSplits[s]?.selectedProduct)) {
                            const lender = $scope.getLender({
                              idLender: reviewProduct?.idLender
                            });
                            reviewProduct.productSplits[s].selectedProduct =
                              homeLoanService.setSelectedProduct({
                                product: reviewProduct?.productSplits[s],
                                lender
                              });
                          }
                        }
                      }

                      $scope.validate();

                      loadDocuments();
                      $scope.verificationsApplicantsIdentified();
                      loadLodgedApplication();
                      loadNotes().then(() => {
                        loadAttachments($scope.Model.availableNotes);
                        $timeout(() => {
                          $scope.getAllAddresses();
                          $scope.Model.isReady = true;
                        });
                      });
                    });
                  }
                } else {
                  $state.transitionTo('factFind', {
                    id: $stateParams.id,
                    dd: $stateParams.dd
                  });
                }
              });
            });
          });
        });
      });
    });
  };

  initialize();

  /*
   * Home loan ~ Switch UI Section
   * --------------------------------------------------------------------------------
   */
  $scope.showSection = (section) => {
    const previousSection = $scope.Model.activeSection.slice();
    $scope.Model.activeSection = section;

    if ($scope.Model.activeSection === 'lodgement') {
      if ($scope.hasDriveOnlineAnyErrors()) {
        $scope.showDriveOnlineErrors();
        $scope.Model.activeSection = previousSection;
      }
    }
  };

  $scope.getNumberOfSection = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    return idx + 1;
  };

  $scope.previous = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    $scope.Model.activeSection =
      section !== 'applicant0' ? $scope.Model.availableSections[idx - 1] : section;
    $scope.showSection($scope.Model.activeSection);
    $location.hash('top');
    $anchorScroll();
  };

  $scope.next = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    $scope.Model.activeSection =
      $scope.Model.availableSections[idx + 1] !== undefined
        ? $scope.Model.availableSections[idx + 1]
        : $scope.Model.availableSections[idx];
    $scope.showSection($scope.Model.activeSection);
    $location.hash('top');
    $anchorScroll();
  };

  $scope.isNextDisabled = () => {
    const idx = $scope.Model.availableSections.indexOf($scope.Model.activeSection);

    if ($scope.Model.availableSections[idx + 1] === 'gateway' && !$scope.isLodgementEnabled()) {
      return true;
    }
    return (
      !$scope.Model.availableSections[idx + 1] ||
      ($scope.Model.activeSection === 'reviewLoanProducts' &&
        ($scope.isAnyOfProductsHaveEmptyInterestOnlyTerm() ||
          $scope.areAnyOfProductsHaveLoanAmountDifferentOfFundingWorksheetsLoanAmount()))
    );
  };

  /*
   * Home loan ~ Helpers
   * --------------------------------------------------------------------------------
   */
  $scope.isDealOwnerBroker = () =>
    authenticationService.isBroker($scope.Model.currentTicket.idOwner);

  $scope.hasHomeLoanTools = () =>
    $scope.isDealOwnerBroker() &&
    $rootScope.hasBrokerToolsEnabled() &&
    $scope.Model.availableLenders.length &&
    $scope.Model.currentWorkflow.isHomeLoan();

  $scope.isLenderExistingInTicketOwnersLenderAccreditations = () => {
    let isExisted = false;
    if (
      $scope.hasHomeLoanTools() &&
      $scope.Model.currentTicketOwner?.lenderAccreditations?.length
    ) {
      const preferredProduct = homeLoanService.getPreferredProduct(
        $scope.Model.currentHomeLoan.compareProducts
      );
      let lender;
      if (preferredProduct?.selectedProduct?.lender?.length) {
        lender = _.find(
          $scope.Model.currentTicketOwner.lenderAccreditations,
          (l) => l?.idLender === preferredProduct.selectedProduct.lender[0]?.id
        );
        isExisted = lender !== undefined;
      } else {
        isExisted = true;
      }
    } else {
      isExisted = true;
    }
    return isExisted;
  };

  $scope.isDealOwnerMentee = () =>
    $rootScope.CurrentOrganization.mentees &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner] !== undefined &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner].length > 0;

  $scope.isDealOwnerHasMentor = () =>
    $rootScope.CurrentOrganization.mentees &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner] &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner].indexOf(
      $rootScope.CurrentAccount.id
    ) > -1 &&
    authenticationService.isBroker($rootScope.CurrentAccount.id);

  $scope.showHomeLoanTools = () =>
    $scope.Model.isReady &&
    $scope.isDealOwnerBroker() &&
    $scope.Model.hasBrokerToolsEnabled &&
    $scope.Model.filteredLenders.length &&
    $scope.Model.currentWorkflow.isHomeLoan();

  $scope.sortByIdContacts = (contacts) => {
    const sortedContacts = [];
    $scope.Model.currentTicket.idClients.forEach((id) => {
      const contact = contacts.find((c) => c.id === id);
      sortedContacts.push(contact);
    });
    return sortedContacts;
  };

  $scope.setCaretClass = (isView) =>
    `${ticketService.setCaretClass(isView)} ${
      $scope.Model.isSidebarMinimized || !$rootScope.IsMedia('gt-sm') ? 'hide' : ''
    }`;

  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), {
        path: '/'
      });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.areAllClientsNonBorrowingSpouse = () =>
    $scope.Model.availableNonBorrowingSpouses?.length ===
      $scope.Model.availablePersonOnlyContacts?.length &&
    $scope.Model.availablePersonOnlyContacts?.length === $scope.Model.availableContacts?.length;

  $scope.areAllClientsSecurityGuarantor = () =>
    $scope.Model.availableSecurityGuarantors?.length ===
      $scope.Model.availablePersonOnlyContacts?.length &&
    $scope.Model.availablePersonOnlyContacts?.length === $scope.Model.availableContacts?.length;

  $scope.areAllClientsCompanyAndSecurityGuarantor = () => {
    const clients = $scope.Model.availableCompanyOnlyContacts.concat(
      $scope.Model.availableSecurityGuarantors
    );
    return clients?.length === $scope.Model.availableContacts?.length;
  };

  $scope.areAllClientsServicingGuarantor = () =>
    $scope.Model.availableServicingGuarantors?.length ===
      $scope.Model.availablePersonOnlyContacts?.length &&
    $scope.Model.availablePersonOnlyContacts?.length === $scope.Model.availableContacts?.length;

  $scope.allContactsAreCompanies = () =>
    _.every($scope.Model.availableContacts, (c) => c.isCompany);

  $scope.showIncome = () =>
    ($scope.Model.availablePersonOnlyContacts.length > 0 &&
      !$scope.areAllClientsSecurityGuarantor()) ||
    ($scope.Model.availablePersonOnlyContacts.length &&
      $scope.Model.availableContacts.length === 1 &&
      !helperService.isClientSecurityGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      })) ||
    $scope.allContactsAreCompanies();

  $scope.showExpenses = () => !$scope.allContactsAreCompanies();

  $scope.showObjectivesInsurancesAndOtherAdvisers = () =>
    ($scope.Model.availablePersonOnlyContacts.length > 0 &&
      !$scope.areAllClientsSecurityGuarantor() &&
      !$scope.areAllClientsServicingGuarantor()) ||
    ($scope.Model.availablePersonOnlyContacts.length &&
      $scope.Model.availableContacts.length === 1 &&
      !helperService.isClientSecurityGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      }) &&
      !helperService.isClientServicingGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      }) &&
      !helperService.isClientNonBorrowingSpouse({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonOnlyContacts[0].id
      })) ||
    $scope.allContactsAreCompanies();

  $scope.getLabel = (idLabel) =>
    _.find($scope.Model.availableFileLabels, (l) => l.id === idLabel);

  $scope.updateTicketValue = (loanAmountWithLmi) => {
    if ($scope.Model.currentTicket?.values?.onceOff !== loanAmountWithLmi) {
      $scope.Model.currentTicket.values.onceOff = loanAmountWithLmi;
      $scope.saveTicket({ values: { onceOff: loanAmountWithLmi } });
    }
  };
  $scope.hasSelectedProduct = () =>
    homeLoanService.getPreferredProduct($scope.Model.currentHomeLoan.compareProducts) !==
    undefined;

  $scope.isThereAnyContactWhoIsCompanyOrSelfEmployed = () =>
    isThereAnyContactWhoIsCompanyOrSelfEmployed($scope.Model.availableContacts);

  $scope.areAllContactsCompanies = () =>
    areAllContactsCompanies($scope.Model.availableContacts);

  $scope.getContact = (idContact) =>
    $scope.Model.availableContacts.find((c) => c.id === idContact);

  $scope.getAllAddresses = () => {
    $scope.Model.availableAddresses = helperService.getAllAddresses(
      $scope.Model.availableContacts,
      $scope.Model.currentTicket.assets,
      $scope.Model.currentTicket.otherAdvisers,
      $scope.Model.currentTicketOwner,
      $scope.Model.currentWorkflow,
      $scope.isDealOwnerBroker(),
      null,
      $scope.Model.currentHomeLoan.securityDetails,
      $scope.Model.currentHomeLoan.compliance
    );
  };

  $scope.getLender = ({ idLender }) =>
    _.find($scope.Model.filteredLenders, (l) => l?.id === idLender);

  $scope.hasPreferredProduct = () => {
    const preferredProduct = homeLoanService.getPreferredProduct(
      $scope.Model.currentHomeLoan.compareProducts
    );
    return preferredProduct !== undefined;
  };

  /*
   * Home loan ~ Income
   * --------------------------------------------------------------------------------
   */
  $scope.incomeAdd = (incomeType, idContact, idEmployer) => {
    incomeService.incomeAdd(
      $scope.Model.currentTicket.income,
      incomeType,
      idContact,
      idEmployer
    );
    if (idContact && idEmployer) {
      $scope.saveIncome({ income: $scope.Model.currentTicket.income });
    }
    $scope.validate();
  };

  $scope.saveIncome = (data) => {
    $scope.saveTicket({ income: data?.income || [], tCD: data?.tCD || '' });
  };

  /*
   * Home loan ~ Expenses
   * --------------------------------------------------------------------------------
   */
  $scope.saveExpenses = (data) => {
    $scope.saveTicket({ expenses: data?.expenses || [], tCD: data?.tCD || '' });
  };

  /*
   * Home loan ~ Assets
   * --------------------------------------------------------------------------------
   */
  $scope.assetAdd = (assetType) => {
    assetsService.assetAdd(
      $scope.Model.currentTicket.assets,
      assetType,
      $scope.Model.availableContacts
    );
    $scope.validate();
  };

  $scope.contactsHaveAssets = () =>
    _.some($scope.Model.availableContacts, (c) => c.assets.length);

  $scope.addContactAssets = (data) => {
    if (data instanceof Asset) {
      const asset = data;
      $scope.addContactAsset(asset);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let a = 0; a < contact.assets.length; a += 1) {
        const asset = contact.assets[a];
        $scope.addContactAsset(asset);
      }
    }
  };

  $scope.addContactAsset = (assetToAdd) => {
    const asset = assetToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      const idx = helperService.findIndexByContactId(
        asset.ownership,
        $scope.Model.availableContacts[i].id
      );
      if (idx === -1) {
        asset.ownership.push(Ownership.blank($scope.Model.availableContacts[i].id, 0));
      }
    }
    const idAssets = _.uniq(_.map($scope.Model.currentTicket.assets, 'id'));
    if (idAssets.indexOf(asset.idReference) === -1) {
      asset.idReference = asset.id;
      $scope.Model.currentTicket.assets.push(Asset.build(asset));
      contactsService.clearCache($scope.Model.currentTicket.assets);
      $scope.saveAssets({ assets: $scope.Model.currentTicket.assets, tCD: 'assets' });
    } else {
      uiService.toast({
        text: {
          p1: 'Asset',
          p2: asset.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveAssets = (data) => {
    $scope.saveTicket({ assets: data?.assets || [], tCD: data?.tCD || '' });
    $scope.updateHomeLoanSecuritySplits(data?.assets || []);
  };

  $scope.updateHomeLoanSecuritySplits = _.debounce((assets) => {
    if (
      !_.isEmpty($scope.Model.currentHomeLoan) &&
      $scope.Model.currentHomeLoan?.securityDetails &&
      $scope.Model.currentHomeLoan?.fundingWorksheets?.fundsRequired?.length &&
      $scope.Model.currentHomeLoan?.fundingWorksheets?.fundsAvailable?.length &&
      !_.isEmpty($scope.Model.currentHomeLoan?.fundingWorksheets?.fundsTotal)
    ) {
      const dataHL = homeLoanService.updateHomeLoanSecuritySplits({
        securityDetails: $scope.Model.currentHomeLoan?.securityDetails || {},
        fundingWorksheets: $scope.Model.currentHomeLoan?.fundingWorksheets || {},
        assets: assets || [],
        contacts: $scope.Model.availableContacts || [],
        ticketClientTypes: $scope.Model.currentTicket?.ticketClientTypes || []
      });
      if (
        !_.isEmpty(dataHL) &&
        dataHL?.sDetails &&
        !_.isEmpty(dataHL?.sDetails) &&
        dataHL?.sDetails?.securitySplits &&
        dataHL?.sDetails?.contactsForValuation &&
        dataHL?.sDetails?.titleDetails &&
        dataHL?.sDetails?.otherMortgages &&
        dataHL?.fWorksheets &&
        !_.isEmpty(dataHL?.fWorksheets) &&
        dataHL?.fWorksheets?.fundsRequired &&
        dataHL?.fWorksheets?.fundsAvailable &&
        dataHL?.fWorksheets?.fundsTotal &&
        !_.isEmpty(dataHL?.fWorksheets?.fundsTotal)
      ) {
        $scope.saveHomeLoan({
          securityDetails: dataHL.sDetails,
          fundingWorksheets: dataHL.fWorksheets
        });
      }
    }
  }, 1500);

  /*
   * Home loan ~ Liabilities
   * --------------------------------------------------------------------------------
   */
  $scope.getLiabilityTypes = () => {
    $scope.Model.availableLiabilityTypes = liabilitiesService.getLiabilityTypes(
      $scope.Model.currentTicket.assets
    );
  };

  $scope.liabilityAdd = (liabilityType) => {
    liabilitiesService.liabilityAdd(
      $scope.Model.currentTicket.liabilities,
      liabilityType,
      $scope.Model.availableContacts
    );
    $scope.validate();
  };

  $scope.contactsHaveLiabilities = () =>
    _.some($scope.Model.availableContacts, (c) => c.liabilities.length);

  $scope.addContactLiabilities = (data) => {
    if (data instanceof Liability) {
      const liability = data;
      $scope.addContactLiability(liability);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let l = 0; l < contact.liabilities.length; l += 1) {
        const liability = contact.liabilities[l];
        $scope.addContactLiability(liability);
      }
    }
  };

  $scope.addContactLiability = (liabilityToAdd) => {
    const liability = liabilityToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      const idx = helperService.findIndexByContactId(
        liability.ownership,
        $scope.Model.availableContacts[i].id
      );
      if (idx === -1) {
        liability.ownership.push(Ownership.blank($scope.Model.availableContacts[i].id, 0));
      }
    }
    const idLiabilities = _.uniq(_.map($scope.Model.currentTicket.liabilities, 'id'));
    if (idLiabilities.indexOf(liability.idReference) === -1) {
      liability.idReference = liability.id;
      $scope.Model.currentTicket.liabilities.push(Liability.build(liability));
      contactsService.clearCache();
      $scope.saveLiabilities({
        liabilities: $scope.Model.currentTicket.liabilities,
        tCD: 'liabilities'
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Liability',
          p2: liability.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.changeLinkedAsset = (liability) => {
    if (
      !_.isEmpty($scope.Model.currentHomeLoan) &&
      $scope.Model.currentHomeLoan.securityDetails &&
      $scope.Model.currentHomeLoan.securityDetails.securitySplits &&
      $scope.Model.currentHomeLoan.securityDetails.securitySplits.length
    ) {
      const security = $scope.Model.currentHomeLoan.securityDetails.securitySplits.find(
        (s) => s.idAsset === liability.idAsset
      );
      if (security) {
        const oMortgages = homeLoanService.addHomeLoanOtherMortgage(
          security.id,
          security.idAsset,
          $scope.Model.currentHomeLoan.securityDetails,
          $scope.Model.currentTicket.liabilities
        );
        if (oMortgages && oMortgages.length) {
          $scope.Model.currentHomeLoan.securityDetails.otherMortgages = oMortgages;
          $scope.saveLiabilities({ liabilities: $scope.Model.currentTicket.liabilities });
        }
      } else {
        let idx = -1;
        if ($scope.Model.currentHomeLoan.securityDetails.otherMortgages) {
          idx = $scope.Model.currentHomeLoan.securityDetails.otherMortgages.findIndex(
            (s) => s.idLiability === liability.id
          );
        }
        if (idx > -1) {
          $scope.Model.currentHomeLoan.securityDetails.otherMortgages.splice(idx, 1);
          $scope.saveLiabilities({ liabilities: $scope.Model.currentTicket.liabilities });
        }
      }
    }
  };

  $scope.saveLiabilities = (data) => {
    $scope.saveTicket({
      liabilities: data?.liabilities || [],
      tCD: data?.tCD || ''
    });
    $scope.updateHomeLoanOtherMortgages(data?.liabilities);
  };

  $scope.updateHomeLoanOtherMortgages = _.debounce((liabilities) => {
    if (
      !_.isEmpty($scope.Model.currentHomeLoan) &&
      $scope.Model.currentHomeLoan?.securityDetails?.otherMortgages?.length
    ) {
      const oMortgages = homeLoanService.updateHomeLoanOtherMortgages(
        $scope.Model.currentHomeLoan.securityDetails.otherMortgages,
        liabilities || []
      );
      if (oMortgages) {
        $scope.Model.currentHomeLoan.securityDetails.otherMortgages = oMortgages;
        $scope.saveHomeLoan({
          securityDetails: $scope.Model.currentHomeLoan?.securityDetails || {}
        });
      }
    }
  }, 1500);

  /*
   * Home loan ~ Open banking
   * --------------------------------------------------------------------------------
   */
  $scope.showOpenBankingData = (event, type) => {
    eventService.dialogOpenBanking({
      event,
      contacts: $scope.Model.openBankingContacts || [],
      openBankingData: $scope.Model.openBankingData || [],
      openBankingDataType: type,
      ticket: $scope.Model.currentTicket
    });
  };

  $scope.hasData = (type) => _.some($scope.Model.openBankingData || [], (o) => o[type]?.length);

  $scope.openBankingFinished = (data) => {
    if (data?.type && data?.selectedData?.length) {
      const updatedData = helperService.processOpenBankingData({
        data,
        ticket: $scope.Model.currentTicket,
        contacts: $scope.Model.availableContacts
      });
      if (updatedData) {
        $scope.Model.currentTicket[data?.type] = updatedData;
        $scope.saveTicket({
          [data?.type]: $scope.Model.currentTicket[data?.type],
          tCD: data?.type
        });
      }
    }
  };

  /*
   * Home loan ~ Objectives
   * --------------------------------------------------------------------------------
   */
  $scope.saveObjectives = _.debounce((objectives) => {
    $scope.saveTicket({ objectives });
  }, 1500);

  /*
   * Home loan ~ Insurance
   * --------------------------------------------------------------------------------
   */
  $scope.getInsuranceTypes = () => {
    $scope.Model.availableInsuranceTypes = insurancesService.getInsuranceTypes({
      assets: $scope.Model.currentTicket.assets
    });
  };

  $scope.canSeeInsuranceType = (insuranceType) =>
    insurancesService.canSeeInsuranceType(insuranceType);

  $scope.insuranceAdd = (insuranceType) => {
    insurancesService.insuranceAdd($scope.Model.currentTicket.insurances, insuranceType);
  };

  $scope.contactsHaveInsurance = () =>
    _.some($scope.Model.availableContacts, (c) => c.insurances.length);

  $scope.addContactInsurances = (data) => {
    if (data instanceof Insurance) {
      const insurance = data;
      $scope.addContactInsurance(insurance);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let i = 0; i < contact.insurances.length; i += 1) {
        const insurance = contact.insurances[i];
        $scope.addContactInsurance(insurance);
      }
    }
  };

  $scope.addContactInsurance = (insuranceToAdd) => {
    const insurance = insuranceToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      if (insurance.idContacts.indexOf($scope.Model.availableContacts[i].id) === -1) {
        insurance.idContacts.push($scope.Model.availableContacts[i].id);
      }
    }
    const idInsurances = _.uniq(_.map($scope.Model.currentTicket.insurances, 'id'));
    if (idInsurances.indexOf(insurance.idReference) === -1) {
      insurance.idReference = insurance.id;
      $scope.Model.currentTicket.insurances.push(Insurance.build(insurance));
      contactsService.clearCache();
      $scope.saveInsurances($scope.Model.currentTicket.insurances);
    } else {
      uiService.toast({
        text: {
          p1: 'Insurance',
          p2: insurance.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveInsurances = _.debounce((insurances) => {
    $scope.saveTicket({ insurances });
  }, 1500);

  /*
   * Home loan ~ Other advisers
   * --------------------------------------------------------------------------------
   */
  $scope.getOtherAdviserTypes = () => {
    $scope.Model.availableOtherAdviserTypes =
      otherAdvisersService.getAvailableOtherAdviserTypes({
        workflow: $scope.Model.currentWorkflow
      });
  };

  $scope.otherAdviserAdd = (otherAdviserType) => {
    otherAdvisersService.otherAdviserAdd(
      $scope.Model.currentTicket.otherAdvisers,
      otherAdviserType
    );
  };

  $scope.saveOtherAdvisers = _.debounce((otherAdvisers) => {
    $scope.saveTicket({ otherAdvisers });
  }, 1500);

  /*
   * Home loan ~ Diversification opportunities
   * --------------------------------------------------------------------------------
   */
  $scope.saveDiversificationOpportunities = _.debounce((diversificationOpportunities) => {
    if (diversificationOpportunities !== undefined) {
      $scope.Model.currentTicket.diversificationOpportunities = diversificationOpportunities;
      $scope.saveTicket({ diversificationOpportunities });
    }
  }, 1500);

  $scope.saveTicketIntegrations = _.debounce((integration, result) => {
    let needsToStore = false;
    if (integration === 'MY_CONNECT' && result?.status && result?.reference) {
      $scope.Model.currentTicket.integrations.myConnectId = result.reference;
      needsToStore = true;
    }
    if (integration === 'ALI' && result && !$scope.Model.currentTicket?.integrations?.aliId) {
      $scope.Model.currentTicket.integrations.aliId = $scope.Model.currentTicket.id;
      needsToStore = true;
    }
    if (integration === 'MOVING_HUB' && result?.customer_id && result?.reference_code) {
      $scope.Model.currentTicket.integrations.movingHub.customerId = result.customer_id;
      $scope.Model.currentTicket.integrations.movingHub.referenceCode = result.reference_code;
      needsToStore = true;
    }
    if (needsToStore) {
      $scope.saveTicket({ integrations: $scope.Model.currentTicket.integrations });
    }
  }, 1500);

  $scope.saveTicketDiversificationOpportunitiesComments = _.debounce(
    (diversificationOpportunitiesComments) => {
      if (diversificationOpportunitiesComments) {
        $scope.Model.currentTicket.diversificationOpportunitiesComments =
          diversificationOpportunitiesComments;
      }
      $scope.saveTicket({
        diversificationOpportunitiesComments:
          $scope.Model.currentTicket.diversificationOpportunitiesComments
      });
    },
    1500
  );

  /*
   * Home loan ~ Flex
   * --------------------------------------------------------------------------------
   */
  $scope.flexConnect = () => {
    if (!$scope.Model.currentTicket.integrations.flexId) {
      $scope.Model.isCreatingFlexOpportunity = true;
      uiService.toast({
        text: {
          p1: 'Creating Opportunity in Flex',
          p2: $scope.Model.currentTicket.getName(),
          p3: 'please wait...'
        },
        warn: true
      });
      flexService.flexConnect({ idTicket: $scope.Model.currentTicket.id }).then((result) => {
        $scope.Model.isCreatingFlexOpportunity = false;
        if (result.status) {
          $scope.Model.currentTicket.integrations.flexId = result.flexId;
          uiService.toast({
            text: {
              p1: 'Successfully created Opportunity',
              p2: $scope.Model.currentTicket.getName(),
              p3: 'in Flex'
            },
            success: true
          });
        } else {
          uiService.toast({
            text: {
              p3: result.errorMessage
            },
            warn: true
          });
        }
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Disconnecting',
          p2: $scope.Model.currentTicket.getName(),
          p3: 'from Flex.'
        },
        warn: true
      });
      ticketService
        .updateTicket({ id: $scope.Model.currentTicket.id, integrations: { flexId: '' } })
        .then(() => {
          uiService.toast({
            text: {
              p1: 'Successfully disconnected',
              p2: $scope.Model.currentTicket.getName(),
              p3: 'from Flex.'
            },
            warn: true
          });
          $scope.Model.currentTicket.flexId = '';
        });
    }
  };

  /*
   * Home loan ~ Needs analysis
   * --------------------------------------------------------------------------------
   */
  $scope.saveNeedsAnalysis = _.debounce((needsAnalysis) => {
    if (needsAnalysis && !_.isEmpty(needsAnalysis)) {
      $scope.Model.currentHomeLoan.needsAnalysis = needsAnalysis;
      $scope.saveHomeLoan({ needsAnalysis });
    }
  }, 500);

  /*
   * Home loan ~ Security details
   * --------------------------------------------------------------------------------
   */
  $scope.saveSecurityDetails = _.debounce((dataToSave) => {
    const data = dataToSave;
    if (data && data.securityDetails) {
      $scope.Model.currentHomeLoan.securityDetails = data?.securityDetails || [];
      $scope.Model.addresses = [];
      $timeout(() => {
        $scope.Model.addresses = _.map(
          $scope.Model.currentHomeLoan?.securityDetails?.securitySplits || [],
          (security) => security.address
        );
      });
    }
    if (data && data.fundingWorksheets && !_.isEmpty(data.fundingWorksheets)) {
      for (let i = 0; i < data.fundingWorksheets.fundsRequired.length; i += 1) {
        data.fundingWorksheets.fundsRequired[i].deleteDateObject();
      }
      $scope.Model.currentHomeLoan.fundingWorksheets = data.fundingWorksheets;
    }
    if (data && data.compliance && !_.isEmpty(data.compliance)) {
      data.compliance.deleteDateObject();
      $scope.Model.currentHomeLoan.compliance = data.compliance;
    }
    if (data && data?.isPropertyDataChanged) {
      $scope.validate();
    }
    if (data && !data?.isPropertyDataChanged && !_.isEmpty(data)) {
      $scope.saveHomeLoan(data);
    }
  }, 1500);

  /*
   * Home loan ~ funding worksheets
   * --------------------------------------------------------------------------------
   */
  $scope.updateFundingWorksheets = (fundingWorksheets) => {
    if (!_.isEmpty(fundingWorksheets)) {
      for (let i = 0; i < fundingWorksheets.fundsRequired.length; i += 1) {
        fundingWorksheets.fundsRequired[i].deleteDateObject();
      }
      $scope.Model.currentHomeLoan.fundingWorksheets = fundingWorksheets;
    }
  };

  $scope.saveFundingWorksheets = (dataToSave) => {
    const data = dataToSave;
    if (data?.securityDetails?.length) {
      $scope.Model.currentHomeLoan.securityDetails = data.securityDetails;
    }
    $scope.updateFundingWorksheets(data?.fundingWorksheets);
    if (data && !_.isEmpty(data)) {
      $scope.saveHomeLoan({
        securityDetails: $scope.Model.currentHomeLoan?.securityDetails,
        fundingWorksheets: $scope.Model.currentHomeLoan?.fundingWorksheets,
        hLCD: data?.hLCD || ''
      });
    }
  };

  /*
   * Home loan ~ Maximum borrowing
   * --------------------------------------------------------------------------------
   */
  $scope.saveMaximumBorrowing = (data) => {
    $scope.Model.maximumBorrowing = financeService.prepareEstimateData({
      lenders: $scope.Model.filteredLenders,
      contacts: $scope.Model.availablePersonOnlyContacts,
      income: $scope.Model.currentTicket?.income || [],
      expenses: _.filter(
        $scope.Model.currentTicket?.expenses || [],
        (e) => e?.id && _.isUuid(e?.id)
      ),
      assets: $scope.Model.currentTicket?.assets || [],
      liabilities: $scope.Model.currentTicket?.liabilities || [],
      ticketClientTypes: $scope.Model.currentTicket?.ticketClientTypes || [],
      homeLoanSecurities: $scope.Model.currentHomeLoan?.securityDetails?.securitySplits || [],
      fundingWorksheets: $scope.Model.currentHomeLoan?.fundingWorksheets || {},
      workflow: $scope.Model.currentWorkflow || {},
      owner: $scope.Model.currentTicketOwner || {},
      isDealOwnerBroker: $scope.isDealOwnerBroker(),
      useGeneric: true
    });
    $scope.Model.hasMaximumBorrowingEstimateData =
      data?.hasMaximumBorrowingEstimateData || false;
    if (data?.maximumBorrowing) {
      $scope.Model.currentHomeLoan.maximumBorrowing = data.maximumBorrowing;
      $scope.saveHomeLoan({
        maximumBorrowing: $scope.Model.currentHomeLoan?.maximumBorrowing,
        hLCD: data?.hLCD || ''
      });
    }
  };

  /*
   * Home loan ~ Search loan products
   * --------------------------------------------------------------------------------
   */
  $scope.saveSearchLoanProducts = (dataToSave) => {
    const data = dataToSave;
    if (!_.isEmpty(data?.searchFields)) {
      const searchFields = HomeLoanSearchProduct.Build(data.searchFields);
      $scope.Model.currentHomeLoan.searchFields = searchFields;
    }
    if (data?.reviewProducts) {
      const reviewProducts = _.map(_.compact(data.reviewProducts), (reviewProduct) =>
        ReviewProduct.Build(reviewProduct)
      );
      $scope.Model.currentHomeLoan.reviewProducts = reviewProducts;
    }
    if (data?.compareProducts) {
      const compareProducts = _.map(_.compact(data.compareProducts), (compareProduct) =>
        CompareProduct.Build(compareProduct)
      );
      $scope.Model.currentHomeLoan.compareProducts = compareProducts;
    }
    if (!_.isEmpty(data)) {
      $scope.saveHomeLoan({
        searchFields: $scope.Model.currentHomeLoan.searchFields,
        reviewProducts: $scope.Model.currentHomeLoan.reviewProducts,
        compareProducts: $scope.Model.currentHomeLoan.compareProducts,
        hLCD: dataToSave?.hLCD
      });
    }
  };

  /*
   * Home loan ~ Review loan products
   * --------------------------------------------------------------------------------
   */
  $scope.isAnyOfProductsHaveEmptyInterestOnlyTerm = () =>
    _.some($scope.Model.currentHomeLoan.reviewProducts, (productReview) =>
      _.some(
        productReview.productSplits,
        (productSplit) =>
          homeLoanService.isProductIO({ product: productSplit }) &&
          productSplit.interestOnlyTerm === 0
      )
    );

  $scope.areAnyOfProductsHaveLoanAmountDifferentOfFundingWorksheetsLoanAmount = () => {
    let totalLoanAmountFW = 0;
    const diff = [];
    if (
      $scope.Model.currentHomeLoan.fundingWorksheets &&
      $scope.Model.currentHomeLoan.fundingWorksheets.fundsAvailable &&
      $scope.Model.currentHomeLoan.fundingWorksheets.fundsAvailable.length
    ) {
      totalLoanAmountFW = $scope.Model.currentHomeLoan.fundingWorksheets.fundsAvailable.reduce(
        (memo, num) => memo + helperService.isNumber(num.proposedLoanAmount, true),
        0
      );
    }
    if (
      $scope.Model.currentHomeLoan.reviewProducts &&
      $scope.Model.currentHomeLoan.reviewProducts.length
    ) {
      $scope.Model.currentHomeLoan.reviewProducts.forEach((p) => {
        const totalLoanAmountRP = _.reduce(
          p?.productSplits || [],
          (memo, n) => _.add(memo, _.toNumber(n?.totalLoanAmount || 0)),
          0
        );
        diff.push(totalLoanAmountFW === totalLoanAmountRP);
      });
    }
    return _.some(diff, (i) => i === false);
  };

  $scope.updateReviewAndCompareProducts = (data) => {
    if (data?.reviewProducts) {
      const reviewProducts = _.map(_.compact(data.reviewProducts), (reviewProduct) =>
        ReviewProduct.Build(reviewProduct)
      );
      $scope.Model.currentHomeLoan.reviewProducts = reviewProducts;
    }
    if (data?.compareProducts) {
      const compareProducts = _.map(_.compact(data.compareProducts), (compareProduct) =>
        CompareProduct.Build(compareProduct)
      );
      $scope.Model.currentHomeLoan.compareProducts = compareProducts;
    }
    if (data?.searchFields) {
      const searchFields = HomeLoanSearchProduct.Build(data.searchFields);
      $scope.Model.currentHomeLoan.searchFields = searchFields;
    }
  };

  $scope.saveReviewLoanProducts = (data) => {
    if (!_.isEmpty(data)) {
      $scope.updateReviewAndCompareProducts(data);
      $scope.saveHomeLoan({
        searchFields: $scope.Model.currentHomeLoan.searchFields,
        reviewProducts: $scope.Model.currentHomeLoan.reviewProducts,
        compareProducts: $scope.Model.currentHomeLoan.compareProducts,
        hLCD: data?.hLCD
      });
    }
  };

  /*
   * Home loan ~ Compare loan products
   * --------------------------------------------------------------------------------
   */
  $scope.saveCompareLoanProducts = (data) => {
    if (data?.compareProducts) {
      const compareProducts = _.map(_.compact(data.compareProducts), (compareProduct) =>
        CompareProduct.Build(compareProduct)
      );
      $scope.Model.currentHomeLoan.compareProducts = compareProducts;
    }
    if (data?.reviewProducts) {
      const reviewProducts = _.map(_.compact(data.reviewProducts), (reviewProduct) =>
        ReviewProduct.Build(reviewProduct)
      );
      $scope.Model.currentHomeLoan.reviewProducts = reviewProducts;
    }
    if (!_.isEmpty(data)) {
      $scope.saveHomeLoan({
        reviewProducts: $scope.Model.currentHomeLoan.reviewProducts,
        compareProducts: $scope.Model.currentHomeLoan.compareProducts
      });
    }
  };

  /*
   * Home loan ~ Commissions
   * --------------------------------------------------------------------------------
   */
  $scope.saveHomeLoanCommission = _.debounce((commission) => {
    if (commission && !_.isEmpty(commission)) {
      $scope.Model.currentHomeLoan.commission = commission;
      $scope.saveHomeLoan({ commission });
    }
  }, 500);

  /*
   * Home loan ~ Refinance analysis
   * --------------------------------------------------------------------------------
   */
  $scope.areThereSecuritiesWithTransactionTypeOfRefinanceOrEquityRelease = () =>
    _.some(
      $scope.Model.currentHomeLoan.fundingWorksheets.fundsRequired,
      (fR) =>
        fR?.transactionType?.name === TransactionType.refinance.name ||
        fR?.transactionType?.name === TransactionType.equity_release.name
    );

  $scope.toggleRefinanceAnalysis = () => {
    if (
      $scope.Model.availableSections.indexOf('refinanceAnalysis') === -1 &&
      $scope.areThereSecuritiesWithTransactionTypeOfRefinanceOrEquityRelease()
    ) {
      const cIdx = $scope.Model.availableSections.indexOf('commissions');
      $scope.Model.availableSections.splice(cIdx, 0, 'refinanceAnalysis');
    } else if (
      $scope.Model.availableSections.indexOf('refinanceAnalysis') > -1 &&
      !$scope.areThereSecuritiesWithTransactionTypeOfRefinanceOrEquityRelease()
    ) {
      const cIdx = $scope.Model.availableSections.indexOf('refinanceAnalysis');
      $scope.Model.availableSections.splice(cIdx, 1);
    }
  };

  $scope.saveRefinanceAnalysis = _.debounce((refinanceAnalysis) => {
    if (refinanceAnalysis && !_.isEmpty(refinanceAnalysis)) {
      $scope.Model.currentHomeLoan.refinanceAnalysis = refinanceAnalysis;
      $scope.saveHomeLoan({ refinanceAnalysis });
    }
  }, 500);

  /*
   * Home loan ~ Compliance comments and documents
   * --------------------------------------------------------------------------------
   */
  $scope.verificationsApplicantsIdentified = () => {
    if (
      !$scope.Model.currentHomeLoan?.compliance?.comments?.applicationSubmission &&
      $scope.Model.currentTicket?.description
    ) {
      $scope.Model.currentHomeLoan.compliance.comments.applicationSubmission =
        $scope.Model.currentTicket?.description;
    }
    if ($scope.Model.availablePersonOnlyContacts?.length) {
      if (!$scope.Model.currentHomeLoan?.compliance?.verifications?.applicants) {
        $scope.Model.currentHomeLoan.compliance.verifications.applicants = [];
      }
      const len = $scope.Model.availablePersonOnlyContacts?.length || 0;
      for (let i = 0; i < len; i += 1) {
        const applicant = $scope.Model.availablePersonOnlyContacts[i];
        const idx = _.findIndex(
          $scope.Model.currentHomeLoan?.compliance?.verifications?.applicants || [],
          (a) => a?.idContact === applicant?.id
        );
        if (idx === -1) {
          $scope.Model.currentHomeLoan.compliance.verifications.applicants.push(
            HomeLoanVerificationApplicant.Blank(applicant?.id)
          );
        }
      }
    }
    const data = {
      compliance: $scope.Model.currentHomeLoan.compliance
    };
    $scope.saveHomeLoanCompliance(data);
  };

  $scope.updateHomeLoanCompliance = (data) => {
    if (!_.isEmpty(data?.compliance)) {
      const compliance = HomeLoanCompliance.Build(data.compliance);
      $scope.Model.currentHomeLoan.compliance = compliance;
    }
  };

  $scope.saveHomeLoanCompliance = (data) => {
    if (!_.isEmpty(data?.compliance)) {
      $scope.updateHomeLoanCompliance(data);
      $scope.saveHomeLoan({
        compliance: $scope.Model.currentHomeLoan.compliance,
        hLCD: data?.hLCD || ''
      });
    }
    if (!_.isEmpty(data?.objectives)) {
      const obj = data.objectives;
      $scope.Model.currentTicket.objectives = obj;
      $scope.saveTicket({ objectives: $scope.Model.currentTicket.objectives });
    }
  };

  /*
   * Home loan ~ Summary
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicketStatusHistory = _.debounce((statusHistory) => {
    if (statusHistory) {
      notesService.clearCache();
      $scope.Model.currentTicket.statusHistory.push(statusHistory);
      $scope.Model.currentTicket.isReadyForVerification = statusHistory.isReadyForVerification;
      $scope.Model.currentTicket.isVerified = statusHistory.isVerified;
      uiService.toast({
        text: {
          p1: 'Deal',
          p2: $scope.Model.currentTicket.getName(),
          p3: 'has been changed status'
        }
      });
      $scope.saveTicket({
        isReadyForVerification: $scope.Model.currentTicket.isReadyForVerification,
        isVerified: $scope.Model.currentTicket.isVerified,
        statusHistory: $scope.Model.currentTicket.statusHistory
      });
    }
  }, 500);

  $scope.saveSummary = (data) => {
    if (data?.reviewProducts?.length) {
      $scope.Model.currentHomeLoan.reviewProducts = data?.reviewProducts;
      $scope.saveHomeLoan({ reviewProducts: $scope.Model.currentHomeLoan.reviewProducts });
    }
  };

  /*
   * Home loan ~ Create documents
   * --------------------------------------------------------------------------------
   */
  $scope.hasFundingWorksheet = () =>
    !_.isEmpty($scope.Model.currentHomeLoan?.fundingWorksheets?.fundsRequired) &&
    !_.isEmpty($scope.Model.currentHomeLoan?.fundingWorksheets?.fundsAvailable);

  $scope.hasCompareProduct = () => $scope.Model.currentHomeLoan?.compareProducts?.length > 0;

  $scope.hasRefinanceAnalysis = () =>
    !_.isEmpty($scope.Model.currentHomeLoan?.refinanceAnalysis);

  $scope.showApplicationPdf = () =>
    helperService.showOptionForCreatingPdfApplication({
      workflow: $scope.Model.currentWorkflow || {},
      hasHomeLoanTools: $scope.hasHomeLoanTools()
    }) && $scope.canSeeApplicationSummary();

  $scope.createHomeLoanToolPdf = ({ pdfType, isView }) => {
    if (pdfType === $scope.Model.availablePdfTypes[0]) {
      const alert = helperService.showAlertForCreatingPdfApplication({
        products: $scope.Model.currentHomeLoan?.compareProducts || [],
        compliance: $scope.Model.currentHomeLoan?.compliance || [],
        objectives: $scope.Model.currentTicket?.objectives || {},
        commission: $scope.Model.currentHomeLoan?.commission || {},
        workflow: $scope.Model.currentWorkflow || {},
        hasHomeLoanTools: $scope.hasHomeLoanTools(),
        isDocument: true
      });
      if (alert?.alerts?.length) {
        const titleStartWord = isView ? 'View' : 'Save';
        alert.title =
          $scope.Model.organizationCountry.cca2 !== 'NZ'
            ? `Error - ${titleStartWord} application summary`
            : `Error - ${titleStartWord} application form`;
        eventService.alertDialog({ alert });
      } else {
        pdfService
          .createPdf({
            contacts: $scope.Model.availableContacts,
            contactLabels: $scope.Model.availableContactLabels,
            lenders: $scope.Model.availableLendersPerCountry,
            ticket: $scope.Model.currentTicket,
            ticketOwner: $scope.Model.currentTicketOwner,
            loan: $scope.Model.currentHomeLoan,
            workflow: $scope.Model.currentWorkflow,
            pdfType,
            isView
          })
          .then(() => {
            if (!isView) {
              loadNotes().then(() => {
                loadAttachments($scope.Model.availableNotes);
              });
            }
          });
      }
    }
    if (pdfType === $scope.Model.availablePdfTypes[2]) {
      pdfService
        .createPdf({
          fundingWorksheets: $scope.Model.currentHomeLoan?.fundingWorksheets || {},
          homeLoanSecurities:
            $scope.Model.currentHomeLoan?.securityDetails?.securitySplits || [],
          ticket: $scope.Model.currentTicket,
          pdfType,
          isQuickTool: false,
          isView
        })
        .then(() => {
          if (!isView) {
            loadNotes().then(() => {
              loadAttachments($scope.Model.availableNotes);
            });
          }
        });
    }
    if (pdfType === $scope.Model.availablePdfTypes[3]) {
      const selectedLenders = _.filter(
        $scope.Model.filteredLenders || [],
        (l) => _.indexOf($scope.Model.currentHomeLoan?.maximumBorrowing?.idLenders, l?.id) > -1
      );
      pdfService
        .createPdf({
          maximumBorrowing: $scope.Model.maximumBorrowing,
          lenders: $scope.Model.availableLendersPerCountry,
          filteredLenders: selectedLenders || [],
          documents: $scope.Model.availableLendersDocuments,
          contacts: $scope.Model.availablePersonOnlyContacts,
          spouses: $scope.Model.availableSpouses,
          ticket: $scope.Model.currentTicket,
          pdfType,
          isQuickTool: false,
          isView
        })
        .then(() => {
          if (!isView) {
            loadNotes().then(() => {
              loadAttachments($scope.Model.availableNotes);
            });
          }
        });
    }
    if (pdfType === $scope.Model.availablePdfTypes[4]) {
      pdfService
        .createPdf({
          compareProducts: $scope.Model.currentHomeLoan?.compareProducts || [],
          reviewProducts: $scope.Model.currentHomeLoan?.reviewProducts || [],
          lenders: $scope.Model.availableLenders || [],
          documents: $scope.Model.availableLendersDocuments || [],
          fundingWorksheets: $scope.Model.currentHomeLoan?.fundingWorksheets || {},
          searchFields: $scope.Model.currentHomeLoan?.searchFields || {},
          ticket: $scope.Model.currentTicket,
          pdfType,
          isQuickTool: false,
          isView
        })
        .then(() => {
          if (!isView) {
            loadNotes().then(() => {
              loadAttachments($scope.Model.availableNotes);
            });
          }
        });
    }
    if (pdfType === $scope.Model.availablePdfTypes[5]) {
      pdfService
        .createPdf({
          refinanceAnalysis: $scope.Model.currentHomeLoan?.refinanceAnalysis,
          ticket: $scope.Model.currentTicket,
          pdfType,
          isQuickTool: false,
          isView
        })
        .then(() => {
          if (!isView) {
            loadNotes().then(() => {
              loadAttachments($scope.Model.availableNotes);
            });
          }
        });
    }
  };

  $scope.areAllRequiredComplianceDocumentsAdded = () =>
    homeLoanService.areAllRequiredComplianceDocumentsAdded(
      $scope.Model.attachmentsCompliance,
      $scope.Model.availableFileLabels
    );

  $scope.getLenderSupportingDocuments = () =>
    helperService.getLenderSupportingDocuments({
      lenderDocuments: $scope.Model.availableLendersDocuments,
      products: $scope.Model.currentHomeLoan?.compareProducts
    });

  $scope.showSpecificDocuments = () => {
    const preferredProduct = helperService.getPreferredProduct({
      products: $scope.Model.currentHomeLoan?.compareProducts
    });
    return (
      $scope.getLenderSupportingDocuments().length > 0 &&
      helperService.isLoanworksGatewaySelected({
        idLender: preferredProduct?.idLender
      })
    );
  };

  $scope.mergeDocuments = ({ documents, isSpecific, filterByContact }) => {
    const deferred = $q.defer();
    if (isSpecific) {
      documentService
        .mergeSpecificDocument({
          idTicket: $scope.Model.currentTicket.id,
          documents
        })
        .then((res) => {
          deferred.resolve(res);
        });
    } else {
      const idDocuments = _.compact(_.map(documents, 'id'));
      documentService
        .mergeDocument({
          idWorkflow: $scope.Model.currentWorkflow.id,
          idStage: $scope.Model.currentTicket.idStage,
          idTicket: $scope.Model.currentTicket.id,
          idDocuments,
          filterByContact
        })
        .then((res) => {
          deferred.resolve(res);
        });
    }
    return deferred.promise;
  };

  $scope.canSeeApplicationSummary = () => {
    const preferredProduct = helperService.getPreferredProduct({
      products: $scope.Model.currentHomeLoan?.compareProducts
    });
    if (!preferredProduct) {
      return false;
    }
    return !helperService.isLoanworksGatewaySelected({ idLender: preferredProduct?.idLender });
  };

  $scope.createDocuments = ({ event, showSpecificDocuments }) =>
    eventService.mergeDocuments({
      event,
      complianceFileLabels: $scope.Model.availableComplianceFileLabels,
      documents: $scope.Model.availableDocuments,
      specificDocuments: $scope.getLenderSupportingDocuments(),
      lenders: $scope.Model.filteredLenders,
      validationErrors: $scope.Model.validation.bidErrors,
      ticket: $scope.Model.currentTicket,
      workflow: $scope.Model.currentWorkflow,
      homeLoan: $scope.Model.currentHomeLoan,
      hasHomeLoanTools: $scope.hasHomeLoanTools(),
      showSpecificDocuments
    });

  $scope.createDocumentsFinished = (data) => {
    if (data && data?.documents?.length) {
      uiService.toast({
        text: {
          p1: 'Document(s) template',
          p2: 'is being prepared',
          p3: 'please wait ...'
        },
        progress: true
      });
      $scope
        .mergeDocuments({
          documents: data?.documents || [],
          isSpecific: data?.isSpecific || false,
          filterByContact: data?.filterByContact || ''
        })
        .then((res) => {
          notesService.clearCache();
          if (!res.status) {
            uiService.toast({
              text: {
                p1: 'Document(s)',
                p2: 'create',
                p3: 'has failed'
              },
              warn: true
            });
          } else {
            loadNotes().then(() => {
              loadAttachments($scope.Model.availableNotes);
              $timeout(() => {
                uiService.toast({
                  text: {
                    p1: 'Document(s)',
                    p2: 'created',
                    p3: 'successfully'
                  }
                });
              });
            });
          }
        });
    }
  };

  $scope.isLodgementEnabled = () =>
    lodgementService.isAnyLodgementEnabled() &&
    ($scope.isDealOwnerMentee() ? $scope.Model.currentTicket.isVerified : true);

  $scope.onGatewaySelected = (gateway) => {
    $scope.Model.currentGateway = gateway;
  };

  $scope.onValidated = (validationErrors) => {
    $scope.Model.validation.errors = validationErrors;
    const cLen = $scope.Model.availableContacts?.length || 0;
    for (let c = 0; c < cLen; c += 1) {
      const contact = $scope.Model.availableContacts[c];
      $scope.Model.validation[`applicant${c}Errors`] = _.filter(
        validationErrors,
        (v) => v?.idContact === contact.id
      );
    }
    $scope.Model.validation.incomeErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('income -') > -1
    );
    $scope.Model.validation.expensesErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('expenses -') > -1
    );
    $scope.Model.validation.assetsErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('assets -') > -1
    );
    $scope.Model.validation.liabilitiesErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('liabilities -') > -1
    );
    $scope.Model.validation.needsAndObjectivesErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('needs and objectives -') > -1
    );
    $scope.Model.validation.productRequirementsErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('product requirements -') > -1
    );
    $scope.Model.validation.securityDetailsErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('security details -') > -1
    );
    $scope.Model.validation.fundingWorksheetErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('funding worksheets -') > -1
    );
    $scope.Model.validation.reviewLoanProductsErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('review loan products -') > -1
    );
    $scope.Model.validation.compareLoanProductsErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('compare loan products -') > -1
    );
    $scope.Model.validation.commissionsErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('commissions -') > -1
    );
    $scope.Model.validation.complianceErrors = _.filter(
      validationErrors,
      (v) => v?.message?.toLowerCase()?.indexOf('compliance comments and documents -') > -1
    );
    $scope.Model.validation.bidErrors =
      $scope.Model.validation?.needsAndObjectivesErrors.concat(
        $scope.Model.validation?.productRequirementsErrors
      );
  };

  $scope.validate = (gatewayErrors) => {
    if ($scope.Model.organizationCountry?.cca2 !== 'NZ') {
      const errors = validationService.validate({
        type: 'hl',
        ticket: $scope.Model.currentTicket,
        homeLoan: $scope.Model.currentHomeLoan
      });
      $scope.Model.validation.errors = errors?.validationErrors || [];
    }

    if ($scope.Model.validation?.errors?.length && !_.isEmpty($scope.Model.currentGateway)) {
      const idLenders = _.compact(_.uniq(_.map($scope.Model.filteredLenders, 'id')));
      const accreditation = _.find(
        $scope.Model.currentTicketOwner?.lenderAccreditations || [],
        (l) => idLenders?.indexOf(l.idLender) > -1
      );
      const errors = $scope.Model.currentGateway.isMinimumFieldsFilled({
        accreditation,
        contacts: $scope.Model.availableContacts || [],
        currentTicketOwner: $scope.Model.currentTicketOwner || {},
        securitySplits: $scope.Model.currentHomeLoan?.securityDetails?.securitySplits || [],
        ticket: $scope.Model.currentTicket || {}
      });
      $scope.Model.validation.errors = _.union(
        $scope.Model.validation.errors,
        errors?.validationErrors || [],
        gatewayErrors || []
      );
    }
    $scope.onValidated($scope.Model.validation.errors);
  };

  /*
   * Home loan ~ Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = () => {
    $state.transitionTo('deal', { id: $stateParams.id, dd: $stateParams.dd });
  };

  /*
   * Home loan ~ Save Contact
   * --------------------------------------------------------------------------------
   */
  $scope.saveContact = (contact) => {
    $scope.validate();
    if (!$scope.Model.currentTicket?.isSettled) {
      $scope.getAllAddresses();
      if (contact.getName() !== 'N/A') {
        contactService.updateContact(contact).then((data) => {
          contactsService.clearCache();
          if (data.status) {
            uiService.toast({
              text: {
                p1: 'Contact',
                p2: contact.getName(),
                p3: 'has been updated'
              },
              success: true
            });
          }
        });
      } else {
        uiService.toast({
          text: {
            p1: 'Contact',
            p2: contact.isCompany ? 'Name' : 'First name and family name',
            p3: contact.isCompany ? 'is required' : 'are required'
          },
          warn: true
        });
      }
    }
  };

  /*
   * Home loan ~ Save Ticket
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicket = (data) => {
    $scope.validate();
    const ticket = data;
    const tCD = data?.tCD || '';
    if (data?.tCD !== undefined) {
      delete ticket.tCD;
    }
    if (!$scope.Model.currentTicket?.isSettled) {
      $scope.getAllAddresses();
      ticket.id = $scope.Model.currentTicket.id;
      ticket.name = $scope.Model.currentTicket.name;
      ticketService.updateTicket(ticket).then((result) => {
        ticketsService.clearCache();
        if (result.status) {
          uiService.toast({
            text: {
              p1: 'Deal',
              p2: $scope.Model.currentTicket.getName(),
              p3: 'has been updated'
            },
            success: true
          });
        }
        eventService.changedData({ changedData: tCD });
      });
    }
  };

  /*
   * Home loan ~ Save Home loan
   * --------------------------------------------------------------------------------
   */
  $scope.saveHomeLoan = (data) => {
    $scope.validate();
    const homeLoan = data;
    const hLCD = data?.hLCD || '';
    if (data?.hLCD !== undefined) {
      delete homeLoan.hLCD;
    }
    if (!$scope.Model.currentTicket?.isSettled) {
      $scope.Model.currentHomeLoan.deleteDateObject();
      homeLoan.id = $scope.Model.currentHomeLoan.id;
      if (!homeLoan.id) {
        homeLoanService.createHomeLoan($scope.Model.currentHomeLoan).then((result) => {
          if (result.status) {
            $scope.Model.currentHomeLoan.id = result.id;
            $scope.Model.currentTicket.idLoan = result.id;
            $scope.saveTicket({ idLoan: $scope.Model.currentTicket.idLoan });
            uiService.toast({
              text: {
                p1: 'Home loan for deal',
                p2: $scope.Model.currentTicket.getName(),
                p3: 'has been created'
              },
              success: true
            });
          }
        });
      } else {
        homeLoanService.updateHomeLoanPartial(data).then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'Home loan for deal',
                p2: $scope.Model.currentTicket.getName(),
                p3: 'has been updated'
              },
              success: true
            });
          }
          eventService.changedData({ changedData: hLCD });
        });
      }
    }
  };
};
